import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";

const Field = ({ value, onChange, placeholder, testId, className = "" }) => (
  <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={`h-8 text-sm ${className}`} data-testid={testId} />
);

export function ExperienceEditor({ items = [], onChange }) {
  const set = (i, patch) => onChange(items.map((x, idx) => (idx === i ? { ...x, ...patch } : x)));
  return (
    <div className="space-y-3" data-testid="experience-editor">
      {items.map((e, i) => (
        <div key={i} className="space-y-2 rounded-[6px] border border-line p-3" data-testid={`experience-row-${i}`}>
          <div className="grid grid-cols-2 gap-2 max-sm:grid-cols-1">
            <Field value={e.title} onChange={(v) => set(i, { title: v })} placeholder="Title" testId={`experience-title-${i}`} />
            <Field value={e.company} onChange={(v) => set(i, { company: v })} placeholder="Company" testId={`experience-company-${i}`} />
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <Field value={e.start_date} onChange={(v) => set(i, { start_date: v || null })} placeholder="Start (YYYY-MM)" className="w-36" testId={`experience-start-${i}`} />
            {!e.is_current && <Field value={e.end_date} onChange={(v) => set(i, { end_date: v || null })} placeholder="End (YYYY-MM)" className="w-36" testId={`experience-end-${i}`} />}
            <label className="flex items-center gap-2 text-xs text-ink-secondary">
              <Switch checked={!!e.is_current} onCheckedChange={(v) => set(i, { is_current: v, end_date: v ? null : e.end_date })} /> Current role
            </label>
            <button className="ml-auto text-ink-muted hover:text-risk" aria-label="Remove role" onClick={() => onChange(items.filter((_, idx) => idx !== i))}><Trash2 size={16} /></button>
          </div>
          {e.description && <p className="text-xs text-ink-muted">{e.description}</p>}
        </div>
      ))}
      <Button variant="ghost" size="sm" className="text-brand" data-testid="experience-add-btn"
        onClick={() => onChange([...items, { title: "", company: "", location: "", start_date: null, end_date: null, is_current: false, description: "" }])}>
        <Plus size={14} /> Add role
      </Button>
    </div>
  );
}

export function EducationEditor({ items = [], onChange }) {
  const set = (i, patch) => onChange(items.map((x, idx) => (idx === i ? { ...x, ...patch } : x)));
  return (
    <div className="space-y-2" data-testid="education-editor">
      {items.map((e, i) => (
        <div key={i} className="grid grid-cols-12 items-center gap-2" data-testid={`education-row-${i}`}>
          <Field value={e.institution} onChange={(v) => set(i, { institution: v })} placeholder="Institution" className="col-span-5" testId={`education-institution-${i}`} />
          <Field value={e.degree} onChange={(v) => set(i, { degree: v })} placeholder="Degree" className="col-span-4" testId={`education-degree-${i}`} />
          <Field value={e.end_date} onChange={(v) => set(i, { end_date: v || null })} placeholder="YYYY-MM" className="col-span-2" testId={`education-end-${i}`} />
          <button className="col-span-1 justify-self-end text-ink-muted hover:text-risk" aria-label="Remove" onClick={() => onChange(items.filter((_, idx) => idx !== i))}><Trash2 size={16} /></button>
        </div>
      ))}
      <Button variant="ghost" size="sm" className="text-brand" data-testid="education-add-btn"
        onClick={() => onChange([...items, { institution: "", degree: "", field: "", start_date: null, end_date: null }])}>
        <Plus size={14} /> Add education
      </Button>
    </div>
  );
}
